/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Form/Item/MultiMedia.ts" />
/// <reference path="../../HTML/Editor/MultiMedia.ts" />
/// <reference path="../../HTML/Editor/MediaContainer.ts" />
namespace HA.Core.Controller.Form {
    import MultiMedia = HA.Core.HTML.Form.MultiMedia;
    import MultiMediaEditor = HA.Core.HTML.Editor.MultiMedia;
    import MediaContainer = HA.Core.HTML.Editor.MediaContainer;

    export class MultiMediaController extends FormItemController {

        /**
         *
         * @returns {any|string}
         */
        public getValue() {
            const list = this.getTag().getSelected(), res = [];

            list.forEach(function(item: any) {
                if (item instanceof MediaContainer) {
                    res.push(item.getFile());
                } else {
                    res.push(item);
                }
            });

            return res;
        }

        /**
         *
         * @returns {boolean}
         */
        public isInputItem() {
            return true;
        }

        /**
         *
         * @returns {any}
         */
        protected createItem() {
            const data = toMap({tag: this.getTag()});
            const me = this;

            data.set("click", () => {
                const tag = new MultiMediaEditor(toMap({
                    dlist: me.getChoices(),
                    title: me.getTitle(),
                    waccept: () => {
                        me.getFormController().closeSelection(me.getAppId());
                        me.replaceItems(tag.getSelections());
                    },
                    wcancel: () => {
                        me.getFormController().closeSelection(me.getAppId());
                    },
                }));
                const app2 = HA.Core.Service.App.createFSApp(tag);
                me.setAppId(app2.getId());
                me.getFormController().showSelection(app2);
            });

            return new MultiMedia(data);
        }

        /**
         *
         * @param items
         */
        protected replaceItems(items: any[]) {
            this.getTag().replaceItems(items);
        }

        /**
         *
         * @returns {Map}
         */
        protected getChoices() {
            return this.getTag().getChoices();
        }
    }
}
